export const LSL_USER_ID_COOKIE = 'lsl_user_id';

export const QF_VALUE = 'QF_VALUE';
